var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTataneuLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 30,
    viewBox: "0 0 186 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8537 7.87165C12.0959 7.46912 12.2575 6.98609 12.2575 6.47622C12.2575 4.94662 10.9922 3.71221 9.45772 3.71221C8.30013 3.71221 7.30406 4.43676 6.87333 5.45649L0.843099 20.3231C0.762337 20.511 0.708496 20.7257 0.708496 20.9403C0.708496 21.7722 1.38151 22.4431 2.21606 22.4431C2.75447 22.4431 3.21212 22.1479 3.48133 21.7185L11.8537 7.87165Z",
    fill: "url(#paint0_linear_2680_20192)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76569 7.0666C6.65801 6.58357 6.65801 6.04687 6.9003 5.48333C7.27719 4.51727 8.13865 3.81955 9.16163 3.71221C10.5615 3.57804 11.7999 4.4636 12.1498 5.72485L18.0185 24.3484C18.2608 25.0461 18.3147 25.8512 18.0993 26.683C17.6686 28.2663 16.2956 29.4471 14.6804 29.6617C12.446 29.9301 10.5077 28.3737 10.1577 26.3074L6.76569 7.0666Z",
    fill: "url(#paint1_linear_2680_20192)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6251 8.67673C29.1366 7.79118 29.4058 6.71777 29.325 5.5907C29.1097 3.04137 27.0099 0.948233 24.4524 0.733552C22.0295 0.545707 19.9028 1.96796 19.0413 4.03427L10.4536 23.9996C10.1575 24.6436 10.0498 25.395 10.1575 26.2C10.3998 28.0248 11.9343 29.5008 13.7649 29.6618C15.4878 29.8228 17.0223 28.9104 17.7491 27.5418L28.6251 8.67673Z",
    fill: "url(#paint2_linear_2680_20192)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8818 9.255V23.3535H44.7138V9.32515L38.8589 9.255V3.43323H58.5922V9.255H52.8818ZM92.8543 9.255V23.3535H84.614V9.32515L78.9037 9.255V3.43323H98.5647V9.255H92.8543ZM72.7596 3.43323L80.783 23.3535H72.6873L68.7118 11.4995L64.3748 23.3535H56.4959L64.3025 3.43323H72.7596ZM112.588 3.43323L120.611 23.3535H112.588L108.54 11.4995L104.203 23.3535H96.3239L104.203 3.43323H112.588Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.465 8.13088V23.1982H129.695V7.8525C129.695 6.4374 130.056 5.34708 130.777 4.58154C131.498 3.81599 132.511 3.43323 133.814 3.43323C134.791 3.43323 135.594 3.68841 136.223 4.19877C136.851 4.70913 137.444 5.61387 138.003 6.91297L142.995 18.6397C143.111 18.9645 143.297 19.1269 143.553 19.1269C143.879 19.1269 144.042 18.9529 144.042 18.6049V3.57242H147.847V18.9181C147.847 20.31 147.498 21.3887 146.8 22.1542C146.079 22.9198 145.078 23.3026 143.798 23.3026C142.844 23.3026 142.029 23.0474 141.354 22.537C140.679 22.0266 140.063 21.1219 139.504 19.8228L134.547 8.09608C134.407 7.7713 134.221 7.60892 133.989 7.60892C133.639 7.60892 133.465 7.78291 133.465 8.13088Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.335 19.4748V23.1981H154.304C153.28 23.1981 152.477 22.9082 151.896 22.3282C151.314 21.7482 151.023 20.9479 151.023 19.9272V6.84334C151.023 5.79942 151.314 4.98748 151.896 4.40752C152.477 3.85076 153.28 3.57239 154.304 3.57239H165.231V7.29571H155.666C155.177 7.29571 154.933 7.53929 154.933 8.02646V11.3322H164.707V14.9511H154.933V18.7441C154.933 19.2312 155.177 19.4748 155.666 19.4748H165.335Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168.373 15.4035V3.57239H172.282V15.4035C172.282 16.6562 172.713 17.6885 173.574 18.5005C174.412 19.3124 175.471 19.7184 176.751 19.7184C178.054 19.7184 179.124 19.3124 179.962 18.5005C180.8 17.6885 181.219 16.6562 181.219 15.4035V3.57239H185.129V15.4035C185.129 17.7465 184.349 19.672 182.79 21.1799C181.207 22.6878 179.194 23.4417 176.751 23.4417C174.33 23.4417 172.329 22.6878 170.746 21.1799C169.164 19.672 168.373 17.7465 168.373 15.4035Z",
    fill: "#231F20"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2680_20192",
    x1: -14.4449,
    y1: 14.9116,
    x2: -4.69176,
    y2: -4.71351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#448CCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7751A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2680_20192",
    x1: 39.5405,
    y1: -5.0693,
    x2: 46.7851,
    y2: 22.0554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7751A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EC168F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2680_20192",
    x1: -11.3715,
    y1: 19.0072,
    x2: 3.9786,
    y2: -11.8778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#EC168F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#F7951D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTataneuLogo);
export default __webpack_public_path__ + "static/media/tataneu_logo.98e9fc9304bc44af0148e6d6cf1f714c.svg";
export { ForwardRef as ReactComponent };